<lps-link-product
  [productCard]="productCard"
  [pathname]="productBaseLink"
  [target]="target"
  [gridName]="gridName"
  [nickname]="nickname"
  class="card-container">


  <div class="card__tag" *ngIf="productCard?.tagCampaign">
    <span>{{ productCard.tagCampaign }}</span>
  </div>

  <div class="card__product-tag" *ngIf="productCard?.tag">
    <span>{{ productCard.tag }}</span>
  </div>

  <div class="card__imagebox" [class.show_grid_3_cols]="showGrid3Cols" >
    <img *ngIf="!showCarousel()" default [src]="photo?.src" [alt]="photo?.name"/>
  </div>

  <div *ngIf="productCard?.label" class="card__label">
    {{productCard?.label}}
  </div>

  <article class="card__textbox">
    <div class="card__textbox_container">

      <div class="icon" *ngIf="!hideBookmark">
        <lps-bookmark
          [productId]="productCard?.sku"
          [displayLinear]="false"
          [displayDescription]="false"
          (click)="stopPropagation($event)">
        </lps-bookmark>
      </div>

      <p class="card__type">{{productCard?.type}}</p>
      <h4 class="card__price" *ngIf="productCard?.priceFormat">
        {{productCard.priceFormat}}
      </h4>
      <h5 class="card__subprice" *ngIf="productCard?.subPrice">
        {{productCard.subPrice}}
      </h5>
      <p class="card__name">{{productCard?.name}}</p>
      <p class="card__location">{{productCard?.street}}</p>
      <p class="card__location">{{productCard?.neighborhood}}</p>
    </div>

    <lps-attributes
      class="card__attributes"
      [attributes]="attributes">
    </lps-attributes>
  </article>

  <div *ngIf="displayRealtorContactLink" class="card__contact">
    <p class="card__contact__text">Falar com o corretor</p>
  </div>
</lps-link-product>
